import { calculator } from "../../../../../utils/cost";
import { calculateDistancePriority, isWashStatus } from "../../../../../utils/recomendation";

export function reallocateVehicles(orderNo,
    selectedVehicles,
    orderList,
    selectedList,
    vehicleList,
    swal,
    modal,
    setShowReallocationModal,
    userToken,
    customers,
    products) {
    // Hedef siparişi bul
    const targetOrder = orderList.find((o) => o.orderNo === orderNo);
    if (!targetOrder) {
        console.error("Target order not found:", orderNo);
        return;
    }

    // Seçilen her araç için işlem yap
    for (const vehicle of selectedVehicles) {
        // Etki altındaki siparişi planlama listesinden çıkar
        if (vehicle.orderNo) {
            const index = selectedList.findIndex(
                (item) => item.orderNo === vehicle.orderNo
            );
            if (index !== -1) {
                selectedList.splice(index, 1);
            }
        }

        // Vehicle list içinde aracın tam detaylarını bul
        const vehicleDetails = vehicleList.find(
            (v) => v.id === vehicle.id || v.plate === vehicle.plate
        );
        vehicleDetails.recomendation = vehicle.recomendation;
        if (vehicleDetails) {
            // Aracı seçilen siparişe ata
            swal.fire({
                icon: "success",
                title: "Araç Yeniden Atandı",
                text: `${vehicle.plate} plakalı araç ${orderNo} numaralı siparişe başarıyla atandı.`,
                confirmButtonText: "Tamam",
            });

            customPlanWithVehicle(targetOrder, vehicleDetails, userToken, customers, products, selectedList);
        } else {
            console.error("Araç detayları bulunamadı:", vehicle.plate);
        }
    }

    // Modal'ı kapat
    modal.hide("reallocation-needed-modal");
    setShowReallocationModal(false);
}

async function customPlanWithVehicle(order, vehicle, userToken, customers, products, selectedList) {
    // Araç bilgisini kullarak sipariş oluşturma
    const distance = calculateDistancePriority(order, vehicle);
    const cost = await calculator(
        userToken,
        1,
        1,
        vehicle,
        order,
        distance,
        0,
        true,
        true,
        1,
        distance / 50
    );

    // Müşteri önceliğini hesapla
    const customerPriority = customers.find((c) => c.name === order.customer)?.priority || 1;

    // Yeni sipariş objesi oluştur
    const newPlannedOrder = {
        ...order,
        vehicleName: vehicle.vehicle || vehicle.plate,
        washCost: cost.totalWashPriceCost,
        washPointName: cost.washPointName,
        recomendationTotalCost: Number(cost.total),
        allCost: Number(cost.total) + Number(cost.totalWashPriceCost),
        vehicle: {
            ...vehicle,
            isRent: vehicle.haveType,
            id: vehicle.id,
            name: vehicle.vehicle || vehicle.plate,
            position: {
                lat: vehicle.latitude,
                lng: vehicle.longitude,
            },
        },
        orderAmount: order.tonnage,
        recomendation: {
            ...vehicle.recomendation,
            distancePriority: distance.toFixed(2),
            vehicleInspectionEndDate: vehicle.vehicleInspectionEndDate,
            inspectionEndDate: vehicle.inspectionEndDate,
            vehicleAdrEndDate: vehicle.vehicleAdrEndDate,
            dorseAdrEndDate: vehicle.dorseAdrEndDate,
            srcEndTime: vehicle.srcEndTime,
            name: vehicle.vehicle || vehicle.plate,
            position: {
                lat: vehicle.latitude,
                lng: vehicle.longitude,
            },
            customerPriority,
            capacity: vehicle.capacity / 1000,
            isWashing: isWashStatus(customers, products, vehicle, order)
                .status,
            isLiveAssignment: true, // Canlı atama bayrağı
        },
        isMultiple: false,
        driver: vehicle.driverName || "",
        dorse: vehicle.dorse || "",
        distance: distance || 0,
    };

    // Planlanmış siparişler listesine ekle
    selectedList.push(newPlannedOrder);

    // Araç kullanım durumunu güncelle
    if (!vehicle.orderNos) {
        vehicle.orderNos = [];
    }
    if (!vehicle.orderNos.includes(order.orderNo)) {
        vehicle.orderNos.push(order.orderNo);
    }
}